export type TFilter<Tabs, Filters> = {
  tab: Tabs;
  /**
   * Tab label. Optional — when omitted, `TableFilterTabs` derives it from the
   * `tab` key against its `labelPrefix` (`<labelPrefix>.<camelCase(tab)>`).
   * Set it only to override that default.
   */
  name?: string;
  permission?: boolean;
  /** Filters merged into the request for this tab. Omit for a tab that adds none. */
  filters?: Partial<Filters>;
  disabled?: boolean;
  badgeNumber?: number;
  badgeColor?: string;
};

/**
 * Dashboard tab keys. These double as the `?tab=` url value *and* as the i18n
 * leaf that `TableFilterTabs` derives a label from
 * (`actions-needed` → `models.patient.table.predefinedFilters.actionsNeeded`),
 * so they live here where the locale audit can resolve them.
 */
export enum EPatientDashboardTab {
  ALL = "all",
  ARCHIVED = "archived",
}

export enum ECotreatmentTabs {
  ACTIONS_NEEDED = "actions-needed",
  IN_PROGRESS = "in-progress",
  IN_TREATMENT = "in-treatment",
  ARCHIVED = "archived",
}

export enum EReferralDashboardTab {
  ACTIONS_NEEDED = "actions-needed",
  REFERRALS_IN = "referrals-in",
  REFERRALS_OUT = "referrals-out",
  ARCHIVED = "archived",
}

// Add to test types if modified.
// Values are persisted as numbers in the `dashboardDefaultTab` preference, so
// only ever append — reordering silently repoints every saved setting.
export enum EPatientTabs {
  IN_TREATMENT,
  IN_TREATMENT_PLAN,
  ACTION_REQUIRED,
  REFERRALS_IN,
  REFERRALS_OUT,
  ARCHIVED,
  ALL,
  REFERRALS_ACTION_REQUIRED,
}

export interface ITableFlags<T = unknown> {
  /**
   * Whether to listen to the url search param
   *
   * defaults to false
   */
  urlSearchOff?: boolean;

  onRowClickOverride?: (event: MouseEvent, row: Record<"item", T>) => void;
  search?: string | null;
  hideKeys?: string[];
}

export const defaultTableFlags = {
  urlSearchOff: false,
} satisfies ITableFlags<any>;
